import { Autocomplete, Divider, TextField } from "@mui/material";

const SearchSelector = ({ value, onChange, options }) => {
  return (
    <Autocomplete
      disablePortal
      options={options}
      sx={{ width: "45%" }}
      onChange={(e, newValue) => onChange(newValue)}
      value={value || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.customerNumber && option.customerName
          ? `${option.customerName} - ${option.customerNumber}`
          : ""
      }
      renderOption={(props, option) => (
        <li
          {...props}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          {option.customerName} || {option.customerNumber}
          <Divider sx={{ width: "100%" }} />
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Usuario / N.cliente" />
      )}
    />
  );
};

export default SearchSelector;
